import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { IUser } from "../types/UserTypes";

interface IUserState {
  users: IUser[];
  selectedUser: IUser | null;
  error: string;
  isLoading: boolean;
  userActionLoading: boolean;
}

const initialState: IUserState = {
  users: [],
  selectedUser: null,
  error: "",
  isLoading: false,
  userActionLoading: false,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    userFetching(state) {
      (state.isLoading = true), (state.error = "");
    },

    getUsersLoading(state) {
      state.isLoading = true;
      state.error = "";
    },

    getUsersSuccess(state, action: PayloadAction<IUser[]>) {
      state.isLoading = false;
      state.error = "";
      state.users = action.payload;
    },

    getUsersFailed(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getUserLoading(state) {
      state.isLoading = true;
      state.error = "";
    },

    getUserSucces(state, action: PayloadAction<IUser>) {
      state.isLoading = false;
      state.error = "";
      state.selectedUser = action.payload;
    },

    getUserFailed(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },

    addUserLoading(state) {
      (state.userActionLoading = true), (state.error = "");
    },

    addUserSuccess(state, action: PayloadAction<IUser>) {
      state.userActionLoading = false;
      state.error = "";
    },
    addUserFailed(state, action: PayloadAction<string>) {
      state.userActionLoading = false;
      state.error = action.payload;
    },

    
    addMessageLoading(state) {
      (state.userActionLoading = true), (state.error = "");
    },

    addMessageSuccess(state, action: PayloadAction<IUser>) {
      state.userActionLoading = false;
      state.error = "";
    },
    addMessageFailed(state, action: PayloadAction<string>) {
      state.userActionLoading = false;
      state.error = action.payload;
    },

    updateUserLoading(state) {
      state.isLoading = true;
      state.error = "";
    },

    updateUserSuccess(state, action: PayloadAction<IUser>) {
      state.isLoading = false;
      state.error = "";

      const index = state.users.findIndex(
        (item) => item.id === action.payload.id
      );
      if (index !== -1) {
        state.users[index] = action.payload;
      }
    },

    updateUserFailed(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },

       deleteUserLoading(state) {
      state.userActionLoading = true;
      state.error = "";
    },

    deleteUserSuccess(state, action: PayloadAction<string>) {
      state.userActionLoading = false;
      state.error = "";
      state.users = state.users.filter((item) => item.id !== action.payload);
    },

    deleteUserFailed(state, action: PayloadAction<string>) {
      state.userActionLoading = false;
      state.error = action.payload;
    },

  },
});

export default userSlice.reducer;
